<template>
  <div class="step1" v-if="content.show">
    <p>请选取6~10个你看重的因素，已选取<span class="protrude">{{chooseValue.length}}</span>个</p>
    <div class="element-box1">
      <p>保健因素：</p>
      <ul class="direction-box">
        <li :class="[selected[0][index]?'selected':'',item.length>5?'col2':'col4']" v-for="(item,index) in content.option1" @click="selectCurrent(item,index,0)">{{item}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>发展因素：</p>
      <ul class="direction-box">
        <li class="col3" :class="selected[1][index]?'selected':''" v-for="(item,index) in content.option2" @click="selectCurrent(item,index,1)">{{item}}
        </li>
      </ul>
    </div>
    <div class="element-box3">
      <p>声望地位因素：</p>
      <ul class="direction-box">
        <li class="col4" :class="selected[2][index]?'selected':''" v-for="(item,index) in content.option3" @click="selectCurrent(item,index,2)">{{item}}
        </li>
      </ul>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      selected: [
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false]
        ],
      chooseValue:[]
    }
  },
  methods:{
    selectCurrent(name,index,sub){
      let num = this.chooseValue.indexOf(name)
      if(num>=0){
        this.chooseValue.splice(num,1)
        this.$set(this.selected[sub], index, false)
      }else{
        if(this.chooseValue.length<10){
          this.chooseValue.push(name)
          this.$set(this.selected[sub], index, true)
          this.$emit("listenToChildEvent",[],this.content.num)
        }else{
          this.content.errorMessage="已经选够10项"
        }
      }
      if(this.chooseValue.length<6){
        this.content.errorMessage="至少选择6项"
        this.$emit("listenToChildEvent",[],this.content.num)
      }else{
        this.content.errorMessage=""
        this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .element-box1
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box2
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .element-box3
    background-color:#C1E7F0
    margin:0.1rem
    padding:0.1rem
  .direction-box
    overflow:hidden
    li
      float:left
      background-color:#FFFFFF
      margin:0.1rem
      padding:1px
      border-radius:6px
      display: flex;
      display:-webkit-flex;
      justify-content: center;/*水平居中*/
      align-items: center;/*垂直居中*/
      -webkit-align-items:center;
      height:0.8rem
      line-height:0.3rem
    .selected
      background-color:#DC6E5A
      color:#ffffff
    .col2
      width:46%
    .col3
      width:29%
    .col4
      width: 21%
      text-align: center
  .protrude
    color:#DC6E5A
    font-weight:bold
</style>
